export default {
  journeys: [],
  pagination: {},
  journey: null,
  nodes: [],
  selectedNodeId: null,
  dirty: false,
  // Contador de edições locais nos nós. O save guarda o valor de partida e, se
  // ele mudou quando a resposta chega, a resposta é tratada como desatualizada.
  revision: 0,
  loading: false,
  saving: false,
  // Reference data
  emailTemplates: [],
  waTemplates: [],
  statuses: [],
  groups: [],
  tags: [],
  forms: [],
  journeysList: [],
  fieldTypes: [],
  refStatuses: {},
  formConditionFields: [],
  followUpRules: [],
  // Analytics
  analytics: {
    metrics: {},
    funnel: [],
    entries: [],
    nodeStats: [],
    logs: { data: [], total: 0 }
  }
}
